import ISelfReadingFormService from './ISelfReadingFormService';
import { injectable } from "inversify";
import SelfReadingPresetDateRolesDTO from '../dtos/SelfReadingPresetDateRolesDTO';
import SelfReadingTypeEnumDTO from '../dtos/SelfReadingTypeEnumDTO';
import IRepository from 'data/IRepository';
import { inversifyContainer } from 'infrastructure/ioc/ioc.container';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import { getQueryParams } from 'features/shared/helpers/queryParams';
import { Requirements_SelfReadingMeter, Requirements_SelfReadingPresetDateRoles, Requirements_SelfReadingType, Requirements_SelfReadingValidate } from 'data/endpoints';
import SelfReadingDatesResult from '../models/SelfReadingDatesResult';
import SelfReadingValidationResultDTO from '../dtos/SelfReadingValidationResultDTO';
import SelfReadingValidationDTO from '../dtos/SelfReadingValidationDTO';
import PostResponse from 'data/PostResponse';

@injectable()
export default class SelfReadingFormService implements ISelfReadingFormService {
  private readonly _typesRepository: IRepository<SelfReadingTypeEnumDTO>;
  private readonly _datesRepository: IRepository<SelfReadingPresetDateRolesDTO>;
  private readonly _meterRepository: IRepository<string>;
  private readonly _validateRepository: IRepository<object>;
    
  constructor() {
    this._typesRepository = inversifyContainer.get<IRepository<SelfReadingTypeEnumDTO>>(IocTypes.Repository);
    this._datesRepository = inversifyContainer.get<IRepository<SelfReadingPresetDateRolesDTO>>(IocTypes.Repository);
    this._meterRepository = inversifyContainer.get<IRepository<string>>(IocTypes.Repository);
    this._validateRepository = inversifyContainer.get<IRepository<object>>(IocTypes.Repository);
  }

  fetchTypes(contractId: string): Promise<SelfReadingTypeEnumDTO[]> {
    return this._typesRepository.get({
      url: Requirements_SelfReadingType,
      params: getQueryParams("ContractId", contractId),
    });
  }

  async fetchDates(contractId: string, selfReadingType: string): Promise<SelfReadingDatesResult> {
    // let dateParams = getQueryParams("ContractId", String(1));
    let dateParams = getQueryParams("ContractId", contractId);
    dateParams.set("SelfReadingType", selfReadingType);

    try {
      let dates = await this._datesRepository.getOne({
        url: Requirements_SelfReadingPresetDateRoles,
        params: dateParams,
      });

      return {
        dates: dates,
        isValid: dates.warning || dates.error ? false : true
      }
    } catch (error) {
      return {
        dates: null,
        isValid: false
      }
    }
  }

  fetchMeter(contractId: string, selfReadingDate: Date | string): Promise<string> {
    let meterParams = getQueryParams("ContractId", contractId);
    meterParams.set("SelfReadingDate", String(selfReadingDate));
    
    return this._meterRepository.getOne({
      url: Requirements_SelfReadingMeter,
      params: meterParams,
    });
  }

  async validateSelfReading(values: Record<string, any>): Promise<PostResponse<SelfReadingValidationResultDTO>> {
    let selfReading: SelfReadingValidationDTO = {
      contractId: values["DESC_TMSmOdecSmlouva"],
      selfReadingType: values["DESC_TMSmOdecDuvodKod"],
      readingDate: values["DESC_TMSmOdecDatum"],
      value: values["DESC_TMSmOdecStavVT"] ? Number(values["DESC_TMSmOdecStavVT"]) : Number(values["DESC_TMSmOdecStav"]),
      meterId: values["DESC_TMSmOdecMeridlo"],
      valueNT: values["DESC_TMSmOdecStavNT"] ? Number(values["DESC_TMSmOdecStavNT"]) : null
    }

    let result = await this._validateRepository.post<SelfReadingValidationResultDTO>({
      url: Requirements_SelfReadingValidate,
      data: selfReading
    });

    return result;
  }
}